@if (breadcrumbs().length > 1) {

  @for (breadcrumb of breadcrumbs().slice(0, hideBreadcrumb() ? 1 : breadcrumbs().length); track $index) {
    <tt-breadcrumb [breadcrumb]="breadcrumb" />
  }

  @if (hideBreadcrumb()) {
    <div class="tt-taxonomy-breadcrumb_more-button" (click)="hideBreadcrumb.set(false)">
      {{ 'GuidelineEditor.TaxonomyBreadcrumb.ShowMultipleNodes' | transloco }}
    </div>
  } @else {
    <div class="tt-taxonomy-breadcrumb_more-button" (click)="hideBreadcrumb.set(true)">
      {{ 'GuidelineEditor.TaxonomyBreadcrumb.HideMultipleNodes' | transloco }}
    </div>
  }
} @else if (breadcrumbs().length === 1) {
  <tt-breadcrumb [breadcrumb]="breadcrumbs()[0]" />
}
